import { Router } from "react-router-dom";
import { createBrowserHistory } from "history";
import { Provider as StoreProvider } from "react-redux";

import { ThemeProvider } from "@mui/material/styles";
import store from "./store";
import Routes from "./Routes";

import MainLayout from "./layout/MainLayout";
import ReactGA from "react-ga";

import NormalizeStyles from "./styles/normalize.js";
import { theme } from "./styles/Theme";
import { useEffect, useState } from "react";

import Cookies from "js-cookie";
import { nanoid } from "nanoid";
import { getPreOrder } from "./store/slicers/preorder";
import { preOrderListWithActions } from "./shared/models/data/preOrderData";
import Spinner from "./shared/ui/components/Spinner";
import useStyles from "./pages/Address/style";
import { getCount } from "./store/slicers/order";

ReactGA.initialize("UA-177237038-1", { gaOptions: { cookieDomain: "auto" } });

const history = createBrowserHistory();

history.listen((location) => {
  ReactGA.set({ page: location.pathname });
  ReactGA.pageview(location.pathname);
});

const App = (): JSX.Element => {
  const [initDataLoaded, setInitDataLoaded] = useState<boolean>(false);
  const styles = useStyles();
  useEffect(() => {
    ReactGA.pageview(window.location.pathname);
  }, []);

  useEffect(() => {
    async function updatePreOrderData() {
      const [{ meta, payload }] = await Promise.all([
        store.dispatch<any>(getPreOrder(Cookies.get("uniqueId"))),
        store.dispatch<any>(getCount()),
      ]);
      if (meta?.requestStatus === "fulfilled") {
        payload.forEach((item: any) => {
          const data = JSON.parse(item.json.replace(/¶œÆ/g, '"'));

          const actionsList = preOrderListWithActions.find((i) => {
            if (i.route === item.route) {
              return i;
            }
          });
          if (!!actionsList) {
            const {
              action,
              actionKey,
              secondAction,
              secondActionKey,
              thirdAction,
              thirdActionKey,
            }: any = actionsList;
            if (thirdAction) {
              store.dispatch<any>(thirdAction(data[thirdActionKey]));
            }
            if (secondActionKey) {
              store.dispatch<any>(action(data[actionKey]));
              store.dispatch<any>(secondAction(data[secondActionKey]));
            } else if (actionsList?.route !== "/price") {
              store.dispatch<any>(action(data[actionKey]));
            } else {
              store.dispatch<any>(action(data));
              store.dispatch<any>(secondAction(data.recipientCountry));
            }
          }
        });
      }

      setInitDataLoaded(true);
    }
    updatePreOrderData();
    if (!Cookies.get("uniqueId")) {
      window.location.href = "/";
      const hour = new Date(new Date().getTime() + 60 * 60 * 1000);
      Cookies.set("uniqueId", nanoid(), { expires: hour });
    }
  }, []);

  return (
    <div className="App">
      <NormalizeStyles />
      <ThemeProvider theme={theme}>
        <StoreProvider store={store}>
          <Router history={history}>
            {initDataLoaded ? (
              <MainLayout>
                <Routes />
              </MainLayout>
            ) : (
              <div className={styles.spinnerWrapperMain}>
                <Spinner size={50} />
              </div>
            )}
          </Router>
        </StoreProvider>
      </ThemeProvider>
    </div>
  );
};

export default App;
